module.exports = __webpack_public_path__ + "img/billing.796f82e2.png";